export function registerSW() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register('/sw.js')
        .then((reg) => {
          console.log('[SW] Registrato:', reg.scope);
          // Force immediate check on every load — without this, iOS
          // Safari can keep an old SW alive for hours, which is what
          // caused customers to keep hitting the legacy "intercept all
          // /api/" handler that produced "Body is disturbed or locked"
          // on the campaign reveal flow.
          reg.update();
          // When a new SW is installed and waiting, tell it to
          // skipWaiting and claim immediately so the user picks up the
          // fixed bundle without a manual hard-refresh.
          reg.addEventListener('updatefound', () => {
            const installing = reg.installing;
            if (!installing) return;
            installing.addEventListener('statechange', () => {
              if (installing.state === 'installed' && navigator.serviceWorker.controller) {
                // A new SW took over. Reload once so the page runs the
                // updated assets it expects.
                window.location.reload();
              }
            });
          });
          // Recurring update check (in addition to the on-load one).
          setInterval(() => reg.update(), 60000);
        })
        .catch((err) => {
          console.log('[SW] Registrazione fallita:', err);
        });
    });
  }
}

export function unregisterSW() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then((reg) => reg.unregister());
  }
}
